import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  Grid,
  Link,
  Tooltip,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import {
  downloadPDF,
  FlippedOrderExpansionPanelSummary,
} from "../../utils/functionsUtils";
import { styleEndowment } from "./styleEndowment";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { headers } from "./headers";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CarnetIcon from "@material-ui/icons/PlaylistAddCheck";
import CloseIcon from "@material-ui/icons/Close";
import {
  cancelEndowment,
  dowloadCard,
  dowloadEndowment,
  getEndowmentByEmployee,
} from "../../actions/endowment-delivery-action";
import { permissionsConstans } from "../../constansPermissions";
import SeeEndowmentModal from "./seeEndowmentModal";
import { useStateValue } from "../../context/store";

const AccordionEndowment = ({
  data,
  maestras,
  message,
  setMessage,
  handleClickClose,
  handleClickCloseSuccess,
  setOpenCard,
  setDataCardFormat,
  setIsOpenModal,
  requestMessage,
  handleClickFingerPrint,
}) => {
  const classes = styleEndowment();
  const [fileEndowment, setFileEndowment] = useState({});
  const [openDetailEndowment, setOpenDetailEndowment] = useState(false);
  const [endowments, setEndowments] = useState([]);
  const [cardTypeList, setCardTypeList] = useState([]);
  const [otherTypeList, setOtherTypeList] = useState([]);
  const [{}, dispatch] = useStateValue();

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if (header.field === "creationDate") {
        const date = data?.creationDate
          ? moment(data?.creationDate).format("DD/MM/YYYY")
          : "";
        return date;
      }
      if (header.field === "deliveryDate") {
        const date = data?.deliveryDate
          ? moment(data?.deliveryDate).format("DD/MM/YYYY")
          : "";
        return date;
      }
      if (header.field === "fullName") {
        const name = data?.employee?.fullName ?? "";
        return name;
      }
      if (header.field === "firstName") {
        const firstName = data?.employee?.firstName;
        return firstName;
      }
      if (header.field === "secondName") {
        const secondName = data?.employee?.secondName ?? "";
        return secondName;
      }
      if (header.field === "surname") {
        const surname = data?.employee?.surname;
        return surname;
      }
      if (header.field === "secondSurname") {
        const secondSurname = data?.employee?.secondSurname ?? "";
        return secondSurname;
      }
      if (header.field === "documentType") {
        const findTypeDocument = maestras?.tipoDocumnetoIdentificacion?.find(
          (x) => x?.key === data?.employee?.documentType
        );
        return findTypeDocument?.value;
      }
      if (header.field === "document") {
        const document = data?.employee?.document;
        return document;
      }
      if (header.field === "regional") {
        const regional = data?.employee?.regional?.name;
        return regional;
      }
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }
        return object[header.field];
      }
      return "";
    }
    return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
  };

  const handleClickCancel = async (info, type) => {
    if (type === "cancel") {
      const newData = {
        endowmentId: info?.id,
        observation: "",
      };
      setMessage({
        description: "¿Está seguro que desea Anular esta entrega de dotación?",
        textButtonSubmit: "ACEPTAR",
        handleClick: () => cancelEndowmentDelivery(newData),
        handleClickOut: () => handleClickClose(),
        type: "QUESTION",
        open: true,
      });
    } else if (type === "carnet") {
      setOpenCard(true);
      setDataCardFormat(info);
      setIsOpenModal(true);
    }
  };

  const cancelEndowmentDelivery = async (info) => {
    setMessage({ ...message, open: false });
    const response = await cancelEndowment(info);
    if (response?.status === 200 || response?.status === 201) {
      const msj = "Formato de entrega de dotación  Anulada";
      requestMessage(msj, "SUCCESS", handleClickCloseSuccess);
    } else if (response?.status > 399) {
      const msj = response?.data?.detail
        ? response?.data?.detail
        : "Ocurrió un error procesando la solicitud, inténtelo nuevamente";
      requestMessage(msj, "WARNING", handleClickClose);
    } else {
      const msj =
        "Ocurrió un error procesando la solicitud, inténtelo nuevamente";
      requestMessage(msj, "WARNING", handleClickClose);
    }
  };

  const getFileByDownload = async (info) => {
    if (info) {
      const pdf = info;
      const name = "Entrega de dotación.pdf";
      downloadPDF(pdf, name);
    } else {
      const msj = "No se encontro información para la descarga";
      requestMessage(msj, "WARNING", handleClickClose);
    }
  };

  const validPerCancelEndowment = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "DOT");
    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.DOT_CANCELAR
      )
    ) {
      return (
        <Tooltip title="Anular" arrow placement="top">
          <CloseIcon
            onClick={(e) => {
              e.stopPropagation();
              handleClickCancel(data, "cancel");
            }}
            className={classes.iconEvent}
            style={{ cursor: "pointer", pointerEvents: "auto" }}
          />
        </Tooltip>
      );
    } else return null;
  };

  const openDetail = async (info) => {
    dispatch({
      type: "DATA_ENDOWMENT",
      dataId: info?.id,
    });
    const endowment = await dowloadEndowment(info?.id);
    setFileEndowment(endowment?.data?.endowmentDocument);
  };

  const downloadFileCard = async (info) => {
    const card = await dowloadCard(info?.id);
    const response = card?.data?.documentResponseDTO?.data;
    if (response) {
      const pdf = response;
      const name = "Formato de carnet.pdf";
      downloadPDF(pdf, name);
    } else {
      const msj = "No se encontro información para la descarga";
      requestMessage(msj, "WARNING", handleClickClose);
    }
  };

  const handleClickLookingEndowment = (info) => {
    setOpenDetailEndowment(true);
    getEndowment(info);
  };

  const getEndowment = async (info) => {
    const response = await getEndowmentByEmployee(info?.id);
    if (response?.status === 200 || response?.status === 201) {
      const data = response?.data;
      data.map((endow) => {
        if (
          endow.typeEndowment?.code !== "OTHERS" &&
          endow?.typeEndowment?.code !== "CARD_AND_MEAT_HOLDER"
        ) {
          setEndowments((item) => item.concat(endow));
        }
        if (endow?.typeEndowment?.code === "CARD_AND_MEAT_HOLDER") {
          setCardTypeList([endow]);
        }
        if (endow.typeEndowment?.code === "OTHERS") {
          setOtherTypeList([endow]);
        }
      });
    }
  };

  const closeModal = () => {
    setOpenDetailEndowment(false);
    setEndowments([]);
    setCardTypeList([]);
    setOtherTypeList([]);
  };

  const validPerDownloadEndowment = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "DOT");
    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.DOT_DESCARGAR
      )
    ) {
      return (
        <>
          <Grid container>
            <Grid item xs={12} md={10} lg={10}>
              <Grid container style={{ margin: "10px 0 15px 10px" }}>
                <Grid item xs={12} md={3} xl={3}>
                  <Typography className={classes.heading}>Formato</Typography>
                  <Typography className={classes.secondaryHeading}>
                    <Link
                      //href="#"
                      underline="always"
                      style={{
                        color: "#4D8D9D",
                        fontWeight: "500",
                        cursor: "pointer",
                        pointerEvents: "auto",
                      }}
                      onClick={(e) => getFileByDownload(fileEndowment?.data)}
                    >
                      Entrega de dotación
                    </Link>
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3} xl={3}>
                  <Typography className={classes.heading}>Fecha</Typography>
                  <Typography className={classes.secondaryHeading}>
                    {fileEndowment?.creationDate?.slice(0, 10)}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3} xl={3}>
                  <Typography className={classes.heading}>
                    Fecha de entrega
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {data?.isSigned
                      ? moment(data?.deliveryDate).format("DD/MM/YYYY")
                      : ""}
                  </Typography>
                </Grid>
                {data?.isSigned ? null : (
                  <Grid item xs={12} md={3} xl={3}>
                    <Typography className={classes.secondaryHeading}>
                      <Link
                        underline="always"
                        style={{
                          color: "#4D8D9D",
                          fontWeight: "500",
                          cursor: "pointer",
                          pointerEvents: "auto",
                        }}
                        onClick={(e) =>
                          handleClickFingerPrint(data, "endowment")
                        }
                      >
                        Firmar
                      </Link>
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} md={2} lg={2}>
              <Typography className={classes.secondaryHeading}>
                <Link
                  underline="always"
                  style={{
                    color: "#4D8D9D",
                    fontWeight: "500",
                    cursor: "pointer",
                    pointerEvents: "auto",
                  }}
                  onClick={(e) => handleClickLookingEndowment(data)}
                >
                  Ver dotación
                </Link>
              </Typography>
            </Grid>
          </Grid>

          {data?.card !== null ? (
            <Grid container>
              <Grid item xs={12} md={10} lg={10}>
                <Grid container style={{ marginLeft: 10 }}>
                  <Grid item xs={12} md={3} xl={3}>
                    <Typography className={classes.heading}>Formato</Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Link
                        underline="always"
                        style={{
                          color: "#4D8D9D",
                          fontWeight: "500",
                          cursor: "pointer",
                          pointerEvents: "auto",
                        }}
                        onClick={(e) => downloadFileCard(data)}
                      >
                        Carnet porta carnet
                      </Link>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={3} xl={3}>
                    <Typography className={classes.heading}>Fecha</Typography>
                    <Typography className={classes.secondaryHeading}>
                      {moment(data?.card?.creationDate).format("DD/MM/YYYY")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={3} xl={3}>
                    <Typography className={classes.heading}>
                      Fecha de entrega
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      {data?.card?.isSigned
                        ? moment(data?.card?.deliveryDate).format("DD/MM/YYYY")
                        : ""}
                    </Typography>
                  </Grid>
                  {data?.card?.isSigned ? null : (
                    <Grid item xs={12} md={3} xl={3}>
                      <Typography className={classes.secondaryHeading}>
                        <Link
                          underline="always"
                          style={{
                            color: "#4D8D9D",
                            fontWeight: "500",
                            cursor: "pointer",
                            pointerEvents: "auto",
                          }}
                          onClick={(e) => handleClickFingerPrint(data, "card")}
                        >
                          Firmar
                        </Link>
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={12} md={2} lg={2}></Grid>
            </Grid>
          ) : null}
        </>
      );
    } else return null;
  };

  return (
    <div style={{ marginTop: 10 }}>
      <Accordion
        style={{ borderLeftStyle: "solid", borderLeftColor: "#F8DF13" }}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={data?.id}
          expandIcon={<ExpandMoreIcon />}
          style={{ pointerEvents: "none" }}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header?.title}
              </Typography>
              <Typography
                className={classes.secondaryHeading}
                style={{ flexBasis: "auto", wordBreak: "normal" }}
              >
                {getValueByKey(data, header)}
              </Typography>
            </div>
          ))}

          <div className={classes.columnEvent}>
            <Tooltip title="Ver detalles" arrow placement="top">
              <VisibilityIcon
                onClick={(e) => openDetail(data)}
                className={classes.iconEvent}
                style={{
                  cursor: "pointer",
                  pointerEvents: "auto",
                  marginRight: 15,
                }}
              />
            </Tooltip>
            {data?.status !== "ANULADO" && data?.card === null ? (
              <Tooltip title="Generar carnet" arrow placement="top">
                <CarnetIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClickCancel(data, "carnet");
                  }}
                  className={classes.iconEvent}
                  style={{
                    cursor: "pointer",
                    pointerEvents: "auto",
                    marginRight: 15,
                  }}
                />
              </Tooltip>
            ) : null}

            {data?.status !== "ANULADO" ? validPerCancelEndowment() : null}
          </div>
        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>
          <Grid container style={{ width: "100%" }}>
            {headers.othersHeaders.map((header) => (
              <div className={classes.columnTwo}>
                <Typography className={classes.heading}>
                  {header?.title}
                </Typography>
                <Typography
                  className={classes.secondaryHeading}
                  style={{ flexBasis: "auto", wordBreak: "normal" }}
                >
                  {getValueByKey(data, header)}
                </Typography>
              </div>
            ))}

            <Grid container spacing={2}>
              {validPerDownloadEndowment()}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <SeeEndowmentModal
        openModal={openDetailEndowment}
        closeModal={closeModal}
        endowments={endowments}
        cardTypeList={cardTypeList}
        otherTypeList={otherTypeList}
      />
    </div>
  );
};

export default AccordionEndowment;
